import React, { Component } from "react";
import { Button } from 'semantic-ui-react';
import PlanModal from "./PlanModal";
import { connect } from "react-redux";
import { resetConnection } from "../../../store/actions/connection";
import { withRouter } from "react-router-dom";
import { getUrlParameters } from '../../../util';
import { setGeoCity } from '../../../store/actions/app';
import { getGeo } from '../../../store/actions/geo';

class ChooseSpeed extends Component {

  constructor(props) {
    super(props);
    this.state = {
      planModal: false,
      city: null,
    };
    this.closePlanModal = this.closePlanModal.bind(this);
    this.openPlanModal = this.openPlanModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  componentDidMount() {
    const city = this.getCityFromQueryString() || this.props.geoCity || null;
    this.setState({ city: city });
    if (!city) {
      this.props.getGeo();
    }
  }

  getCityFromQueryString() {
    const params = getUrlParameters();
    const city = params["city"];
    if (city) {
      this.props.setGeoCity(city);
    }
    return city;
  }

  openPlanModal(e) {
    // 
    e.preventDefault();
    this.setState({
      planModal: true
    });
  }

  closePlanModal() {
    // 
    this.setState({
      planModal: false
    });
  }

  openModal(e) {
    // 
    this.props.history.push('/check');
  }

  render() {
    const { geoCity } = this.props;
    const { planModal, city } = this.state;
    const selectedCity = city || geoCity || null;

    return <section className="choose-speed" id="speed_section">
      <div className="ui container grid pos-relative">
        <div className="sixteen wide tablet seven wide computer left aligned sm-text-center align column pos-initial">
          <h3 className="title">CHOOSE YOUR SPEED</h3>
          <div className="display-1">
            From fast to crazy-fast, we don't do slow.
        </div>
          <p className="desc">
            All plans come with unlimited usage plus equal download and upload speeds. No long-term commitment.
        </p>
          <a className="plan-text cursor-pointer" onClick={this.openPlanModal}>
            Which plan is right for me?
        </a>
        </div>
        <div className="sixteen wide tablet seven wide computer column right floated">
          <div className="ui items unstackable">
            <div className="item ui segment center aligned no-decoration" onClick={this.openModal}>
              <div className="ui large horizontal statistic">
                <div className="value display-1">100</div>
                <div className="label">Mbps</div>
              </div>
              <div className="right floated column vertical ui segment middle aligned">
                {
                    selectedCity === 'British Columbia' ?
                    <Button className="ui button prime small">
                      $50/mo
                    </Button>
                    :
                    <Button className="ui button prime small">
                      $55/mo
                    </Button>
                  }
                <div className="small text-grey">Limited Time Offer</div>
              </div>
            </div>
            <div className="item ui segment center aligned no-decoration" onClick={this.openModal}>
              <div className="ui large horizontal statistic">
                <div className="value display-1">750</div>
                <div className="label">Mbps</div>
              </div>
              <div className="right floated column vertical ui segment middle aligned">
                  {
                    selectedCity === 'British Columbia' ?
                    <Button className="ui button prime small">
                      $50/mo
                    </Button>
                    :
                    <Button className="ui button prime small">
                      $55/mo
                    </Button>
                  }
                <div className="small text-grey">Limited Time Offer</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PlanModal open={planModal} closeModal={this.closePlanModal} />
    </section>
  }
}

const mapStateToProps = state => {
  return {
    address: state.connection.address,
    geoCity: state.app.geoCity,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetConnection: () => dispatch(resetConnection()),
    getGeo: () => dispatch(getGeo()),
    setGeoCity: (city) => dispatch(setGeoCity(city)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ChooseSpeed)
);



// WEBPACK FOOTER //
// ./src/components/home/choose-speed/ChooseSpeed.js